import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import InstallPrompt from "./components/InstallPrompt";
import Home from "./pages/Home";
import QrLanding from "./pages/QrLanding";
import Artwork from "./pages/Artwork";
import Paywall from "./pages/Paywall";
import Museum from "./pages/Museum";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import PrintLabel from "./pages/PrintLabel";
import PrintMuseum from "./pages/PrintMuseum";

import AdminLogin from "./pages/admin/Login";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminMuseums from "./pages/admin/Museums";
import AdminCities from "./pages/admin/Cities";
import AdminArtworks from "./pages/admin/Artworks";
import AdminUsers from "./pages/admin/Users";
import AdminPlaces from "./pages/admin/Places";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          position="top-center"
          richColors
          toastOptions={{
            style: { fontFamily: "Outfit, sans-serif" },
          }}
        />
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/q/:code" element={<QrLanding />} />
          <Route path="/opera/:id" element={<Artwork />} />
          <Route path="/paywall/:id" element={<Paywall />} />
          <Route path="/museo/:id" element={<Museum />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancel" element={<PaymentCancel />} />
          <Route path="/print/:code" element={<PrintLabel />} />
          <Route path="/print/museo/:id" element={<PrintMuseum />} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/*" element={<AdminLayout />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="musei" element={<AdminMuseums />} />
            <Route path="citta" element={<AdminCities />} />
            <Route path="opere" element={<AdminArtworks />} />
            <Route path="utenti" element={<AdminUsers />} />
            <Route path="luoghi" element={<AdminPlaces />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <InstallPrompt />
      </BrowserRouter>
    </div>
  );
}

export default App;
